import React from 'react'
import { EditorState,ContentState, RichUtils,convertFromHTML,
        convertToRaw,convertFromRaw,Modifier,CompositeDecorator } from 'draft-js';
import { stateToHTML } from "draft-js-export-html";
import Editor, { createEditorStateWithText } from '@draft-js-plugins/editor';

import createEmojiPlugin from '@draft-js-plugins/emoji';
//import '@draft-js-plugins/emoji/lib/plugin.css';
import './emoji.css';

import "draft-js/dist/Draft.css";
import $ from 'jquery';
import moment from 'moment';
const emojiPlugin = createEmojiPlugin({useNativeArt: false,selectButtonContent:<svg width="26" height="26" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.0002 20.6668C16.0628 20.6668 20.1668 16.5628 20.1668 11.5002C20.1668 6.43755 16.0628 2.3335 11.0002 2.3335C5.93755 2.3335 1.8335 6.43755 1.8335 11.5002C1.8335 16.5628 5.93755 20.6668 11.0002 20.6668Z" stroke="#04BAF2" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M7.3335 13.3335C7.3335 13.3335 8.7085 15.1668 11.0002 15.1668C13.2918 15.1668 14.6668 13.3335 14.6668 13.3335" stroke="#04BAF2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M8.25 8.75H8.2575" stroke="#04BAF2" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M13.75 8.75H13.7575" stroke="#04BAF2" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>});
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
const text ="";
//const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''));

class DraftJsEditorComment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorStateComment: EditorState.createEmpty(),
      errors: {},
      commentTextCount:0,
      waiting:'',
      empty_txt:""
    }
  }
  componentDidMount(){
      this.focus();
  }
  
  onChange = (editorStates) => {
    this.setState({
      editorStateComment:editorStates,empty_txt:0
    });
    var current_content_cnt = editorStates.getCurrentContent().getPlainText('\u0001').length;
//    this.setState({commentTextCount:current_content_cnt});
    var errors = this.state.errors;
    if(current_content_cnt > 500){
        errors['text_limit_error']="Text limit should not exceed 500 characters";
    }else{
        $(".editors").css("border","none");
        errors['text_limit_error']="";
    }
    this.setState({commentTextCount:current_content_cnt,errors});
  }
  
  focus = () => {
    this.editor.focus();
  };
  
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    
    saveEditorDataForComment=()=>{
        this.setState({waiting:'loading'});
        var apiRequestTime = moment().unix();
//        return false;
//        $("#bol_comment_btn").prop("disabled",true);
        const contentState = this.state.editorStateComment.getCurrentContent();
        const text = contentState.getPlainText().trim();
        if (text === '') {
//            $("#bol_comment_btn").prop("disabled",false);
            this.focus();
            this.setState({empty_txt:1,waiting:''});
            return false;
        }
        var editor_text_count = this.state.commentTextCount;
        if(editor_text_count > 500){
            var errors = this.state.errors;
            errors['text_limit_error'] = "Text limit should not exceed 500 characters";
            this.setState({errors});
//            $("#bol_comment_btn").prop("disabled",false);
            this.setState({waiting:""});
            return false;
        }
        const fd = new FormData;
        var is_comment = 1;
        var post_id = this.props.post_id ? this.props.post_id : "";
        var post_type = this.props.commentPostType ? this.props.commentPostType : "";
        var user_id = this.props.userId;
        var userEmail = this.props.userEmail;
        var current_content = this.state.editorStateComment.getCurrentContent();
        const rawEditorContent = convertToRaw(current_content);
        const draft_js_content = JSON.stringify(rawEditorContent);
        let html = stateToHTML(this.state.editorStateComment.getCurrentContent());
        let original_html = html;
        const entityMap = rawEditorContent.entityMap;
        original_html = original_html.replace(/<p><br[\/]?><[\/]?p>/g, '');
        let post_to_save = original_html;
        fd.append("user_id",user_id);
        fd.append("parent_post_id",post_id);
        fd.append("post_id",post_id);
        fd.append("follow_relation_type",post_type);
        fd.append("post_type",post_type);
        fd.append("email_id",userEmail);
        fd.append("is_my_post",1);
        fd.append("message",post_to_save);
        fd.append("is_comment",is_comment);
        fd.append("post_by",user_id);
        fd.append("draft_js_content",draft_js_content);
        fd.append("original_html",original_html);
        fd.append("temp_post_id",apiRequestTime);
        var created_date = moment().utcOffset(0, false).format();
        if(created_date){
            fd.append("created_date",created_date);
        }
        const comment_data_obj = {};
        comment_data_obj._id = apiRequestTime;
        comment_data_obj.post_id = apiRequestTime;
        comment_data_obj.parent_post_id = this.props.post_id;
        comment_data_obj.post_type = post_type;
        comment_data_obj.is_comment = is_comment;
        comment_data_obj.is_liked = 0;
        comment_data_obj.likes = 0;
        comment_data_obj.likes_by = [];
        comment_data_obj.post = post_to_save;
        comment_data_obj.original_html = original_html;
        comment_data_obj.post_by = parseInt(user_id);
        comment_data_obj.draft_js_content = rawEditorContent;
        comment_data_obj.follow_relation_type = post_type;
        comment_data_obj.post_type = post_type;
        this.props.saveCommentDataP(this.props.commentList,comment_data_obj,this.props.commentPostType,this.props.parentPostKey);
        this.forceUpdate();//return false;
//        comment_data_obj.hash_tags = hash_tags;
        fetch(this.props.bolApi+'/bol/savePost', {
            method: 'POST',
                    dataType: 'json',
                    body: fd
            })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({waiting:''});
                if(findresponse.code == 200){
//                    $("#bol_comment_btn").prop("disabled",false);
//                    comment_data_obj._id = findresponse.post_id;
//                    comment_data_obj.post_id = findresponse.post_id;
//                    this.props.saveCommentDataP(this.props.commentList,comment_data_obj,this.props.commentPostType,this.props.parentPostKey);
                    
                }else if(findresponse.code == 500){
//                    $("#bol_comment_btn").prop("disabled",false);
                    this.focus();
                    $(".editors").css("border","2px #04BAF2 solid");
                    return false;
                }
            });
  }
  
    componentDidUpdate=(prevProps, prevState) => {
        if(prevProps !== this.props){ 
            var html = this.props.edit_post_add ? this.props.postContentEdit.original_html:"";//`<p>as sdfdsg sdgsd &nbsp;asd asd #muvi <a href=\"http://localhost:3000/viewEmployee/137\">@Ranjita</a> 😆</p>`;
            var blocksFromHTML = html ? convertFromHTML(html):"";
            var content = blocksFromHTML ? ContentState.createFromBlockArray(
              blocksFromHTML.contentBlocks,
              blocksFromHTML.entityMap
            ):{};
            if(this.props.edit_post_add){
                if(this.props.isComment){
                    this.setState({
//                        editorState:EditorState.createWithContent(content),
                        editorStateComment:EditorState.createWithContent(convertFromRaw(this.props.postContentEdit.draft_js_content)),
                    });
                }else{
                    var attachment_arr = [];
                    if(this.props.postContentEdit.hasOwnProperty('attachment_files')){
                        var existing_attached_value = Object.values(this.props.postContentEdit.attachment_files);
                        if(Object.keys(this.props.postContentEdit.attachment_files).length > 0){
                        for (var i= 0;i< Object.keys(this.props.postContentEdit.attachment_files).length;i++){
                                attachment_arr[i]= existing_attached_value[i];
                            }
                        }
                    }
                    this.setState({
//                        editorState:EditorState.createWithContent(content),
                        editorStateComment:EditorState.createWithContent(convertFromRaw(this.props.postContentEdit.draft_js_content)),
                        attached_file:attachment_arr
                        });
                }
                var postType = this.props.bol_type;
                if(postType){
                    this.setState({postType});
                }
            }else{
                 this.setState({
                    ...this.state,
                    editorStateComment: EditorState.createEmpty(),attached_file:[],errors:{}
                  });
            }
        }
    }
    
  render() {
    return(
            <div>
                <div class="inner-content">
                    <div class="left-content">
                        <EmojiSuggestions /><EmojiSelect />
                        <div className={`editorContainer`+ (this.state.empty_txt ? ' empty-editor':'')}>
        <div className="editors" onClick={this.focus}>
            <Editor 
              editorState={this.state.editorStateComment}
              onChange= { this.onChange }
              plugins={[emojiPlugin]}
              ref={ editor => {
                this.editor = editor;
              }}
              placeholder="Add your comment here"
              />
        </div>
      </div>
        </div>
        <div class="right-content">
            {this.state.waiting == "" ?
            <button type="button" id="bol_comment_btn" class="box-submit" onClick={this.saveEditorDataForComment} title="Submit">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.83999 11.4999H4.42066L2.60841 4.29036C2.5968 4.24846 2.58973 4.20543 2.58732 4.16203C2.56716 3.50111 3.29499 3.04278 3.92566 3.34528L20.9207 11.4999L3.92566 19.6546C3.30232 19.9544 2.58366 19.5089 2.58732 18.8599C2.58918 18.8019 2.59937 18.7444 2.61757 18.6894L3.96232 14.2499" stroke="#04BAF2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>                                            
            </button>
            :
                        <button type="button" id="bol_comment_btn" class="box-submit" disabled="disabled" title="Submit">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.83999 11.4999H4.42066L2.60841 4.29036C2.5968 4.24846 2.58973 4.20543 2.58732 4.16203C2.56716 3.50111 3.29499 3.04278 3.92566 3.34528L20.9207 11.4999L3.92566 19.6546C3.30232 19.9544 2.58366 19.5089 2.58732 18.8599C2.58918 18.8019 2.59937 18.7444 2.61757 18.6894L3.96232 14.2499" stroke="#04BAF2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>                                            
            </button>
            }
        </div>
    </div>
    <div class="error-message">{this.state.errors.text_limit_error}</div>
</div>
      
    )
  }
}

export default DraftJsEditorComment;



// WEBPACK FOOTER //
// ./src/components/bol/DraftJsEditorComment.js